import { render, staticRenderFns } from "./registered-coupons.vue?vue&type=template&id=7b8082ee"
import script from "./registered-coupons.vue?vue&type=script&lang=js"
export * from "./registered-coupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports